import { Link } from "react-router-dom";

export default function SEOContentSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <span className="inline-block text-xs uppercase tracking-[0.15em] text-foreground-400 border border-foreground-200/60 rounded-full px-3 py-1 mb-6 font-label">
              In-Depth Analysis
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight mb-2">
              Why PandabuySpreadsheet
            </h2>
            <h3 className="font-heading text-3xl md:text-4xl text-foreground-400/70 leading-tight mb-8">
              Matters for Smart Shoppers
            </h3>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              PandabuySpreadsheet is a curated discovery platform that organizes the best Pandabuy finds into structured spreadsheets. Instead of wasting hours searching through scattered forums and social media threads, users get instant access to verified sneaker spreadsheets, streetwear collections, budget-friendly finds under $50, and trending TikTok Pandabuy items — all organized in one SEO-optimized hub.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              We simplify Pandabuy shopping into a Google-indexed discovery system that saves time and helps shoppers find the best deals across every product category.
            </p>

            <Link
              to="/blog/pandabuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-primary-500 font-medium text-sm hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap underline underline-offset-4"
            >
              Read Full Guide <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-[60%] flex items-start gap-4">
            <div className="flex-1 space-y-4">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Designer%20sneakers%20pair%20in%20cream%20and%20beige%20tones%20with%20visible%20texture%20details%20on%20light%20sand%20colored%20surface%20soft%20side%20window%20light%20editorial%20product%20photography%20minimalist%20clean%20European%20aesthetic%20warm%20natural%20feel&width=500&height=400&seq=seo-section-1&orientation=landscape"
                  alt="Premium Pandabuy sneakers collection"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Folded%20streetwear%20essentials%20including%20sage%20green%20hoodie%20and%20white%20tee%20on%20light%20wool%20blanket%20surface%20soft%20natural%20daylight%20editorial%20fashion%20flatlay%20photography%20clean%20minimalist%20Scandinavian%20style%20warm%20cozy%20atmosphere&width=500&height=500&seq=seo-section-2&orientation=squarish"
                  alt="Trending Pandabuy streetwear essentials"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}